import { render, staticRenderFns } from "./AddFreeBoxTime.vue?vue&type=template&id=68d78bd1&scoped=true&"
import script from "./AddFreeBoxTime.vue?vue&type=script&lang=js&"
export * from "./AddFreeBoxTime.vue?vue&type=script&lang=js&"
import style0 from "./AddFreeBoxTime.vue?vue&type=style&index=0&id=68d78bd1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d78bd1",
  null
  
)

export default component.exports